import {
  Table as MantineTable,
  TableProps as MantineTableProps,
  rem,
  ScrollArea,
  ScrollAreaProps,
} from "@mantine/core";

interface TableProps extends MantineTableProps {
  /**
   * Styles the scroll area's frame (border, radius). A minimum width goes on the table through
   * `miw`, so only the table scrolls: on the scroll area it would widen the whole page instead.
   */
  scrollStyle?: Omit<React.CSSProperties, "minWidth">;
  scrollProps?: ScrollAreaProps;
  "data-testid"?: string;
}

export default function ScrollableTable({
  scrollStyle,
  scrollProps,
  "data-testid": dataTestId,
  children,
  ...props
}: TableProps) {
  return (
    <ScrollArea
      data-testid={dataTestId}
      styles={{
        viewport: {
          paddingBottom: 0,
        },
      }}
      style={{
        borderRadius: rem(8),
        border: "1px solid var(--mantine-color-cream-4)",
        ...(scrollStyle ?? {}),
      }}
      {...(scrollProps ?? {})}
    >
      <MantineTable verticalSpacing="lg" borderColor="cream.4" horizontalSpacing="xl" {...props}>
        {children}
      </MantineTable>
    </ScrollArea>
  );
}
